// NavLink.js - Active-aware navigation link component
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NavLink = ({
  to,
  icon: Icon,
  label,
  onClick,
  className = '',
  showIcon = true,
  showLabel = true
}) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`
        flex items-center gap-2 px-3 py-2 rounded-md transition-colors
        ${isActive
          ? 'bg-blue-600 text-white'
          : 'text-gray-300 hover:text-white hover:bg-gray-700'
        }
        ${className}
      `}
    >
      {showIcon && Icon && <Icon className="w-4 h-4 flex-shrink-0" />}
      {showLabel && <span className="truncate">{label}</span>}
    </Link>
  );
};

export default NavLink;
